import { GridColumn } from '../../../../../../generic/grid-table'
import type { IReceiptReportLine } from '../../../../../../modules/API/Reciept/models/receipt'
import { convertToDate } from '../../../../../../modules/convertDateString'
import { isValidYmdDate } from '../../../../../../generic/utils/forDate/isValidYmdDate'
import { formatFixed } from '../../../procedures/shared/helpers/formatNumber'
import { PAYMENT_TYPE, PaymentType } from '../../../receipt/generic/getDetailesByPaymentType'

type CellValue = IReceiptReportLine[keyof IReceiptReportLine]

// Dates come as yyyyMMdd and sort correctly as raw strings; only the shown text is formatted.
const formatDate = (value: CellValue): string => (isValidYmdDate(value) ? convertToDate(String(value)) : '')

const formatPaymentType = (value: CellValue): string => PAYMENT_TYPE[value as PaymentType]?.name ?? String(value ?? '')

/** 0 is the server's "none" for cheque and branch numbers and foreign sums. */
const formatNonZero = (value: CellValue): string => (value ? String(value) : '')

const formatCurrencySum = (value: CellValue): string => (typeof value === 'number' && value ? formatFixed(value) : '')

export const buildReceiptsReportColumns = (): GridColumn<IReceiptReportLine>[] => [
  { key: 'RecieptNum', title: 'מס׳ קבלה', dataType: 'number', sortable: true },
  { key: 'DateReg', title: 'תאריך', dataType: 'string', sortable: true, formatValue: formatDate },
  { key: 'CustomerName', title: 'לקוח', dataType: 'string', sortable: true },
  { key: 'SellerName', title: 'משווק', dataType: 'string', sortable: true },
  { key: 'PaymentType', title: 'אמצעי תשלום', dataType: 'string', sortable: true, formatValue: formatPaymentType },
  { key: 'Sum', title: 'סכום', dataType: 'float', sortable: true, currencySuffix: '₪' },
  { key: 'ValueDate', title: 'תאריך פירעון', dataType: 'string', sortable: true, formatValue: formatDate },
  { key: 'Currency', title: 'מטבע', dataType: 'string', sortable: true },
  { key: 'CurrencySum', title: 'סכום במטבע', dataType: 'float', sortable: true, formatValue: formatCurrencySum },
  { key: 'Cheque', title: 'מס׳ שיק', dataType: 'number', sortable: true, formatValue: formatNonZero },
  { key: 'BankName', title: 'בנק', dataType: 'string', sortable: true },
  { key: 'Branch', title: 'סניף', dataType: 'number', sortable: true, formatValue: formatNonZero },
  { key: 'Canceled', title: 'מבוטל', dataType: 'boolean', sortable: true },
  { key: 'FilledBy', title: 'הוזן ע״י', dataType: 'string', sortable: true },
]
